import { css } from '@emotion/react';
import color from 'components/common/color';

export const headerStyles = css`
  position: relative;
  z-index: 10;
  font-family: "Roboto", sans-serif;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const topBarStyles = css`
  display: flex;
  align-items: center;
  gap: 32px;
  height: 56px;
  padding: 0 24px;
  background-color: ${color.BLUE};
  color: ${color.WHITE};
`;

export const brandStyles = css`
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: ${color.WHITE};
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.3px;

  img {
    border-radius: 6px;
    background-color: ${color.WHITE};
    object-fit: cover;
  }
`;

export const moduleNavStyles = css`
  display: flex;
  align-self: stretch;
  gap: 4px;
  flex: 1;
`;

export const moduleLinkStyles = css`
  display: flex;
  align-items: center;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.72);
  border-bottom: 3px solid ${color.TRANSPARENT};
  border-top: 3px solid ${color.TRANSPARENT};
  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    color: ${color.WHITE};
  }

  &.active {
    color: ${color.WHITE};
    border-bottom-color: ${color.ORANGE};
  }
`;

export const logoutButtonStyles = css`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 14px;
  font-family: inherit;
  font-size: 14px;
  color: ${color.WHITE};
  background: ${color.TRANSPARENT};
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  i {
    margin: 0;
    color: inherit;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }
`;

export const subNavStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 24px;
  min-height: 44px;
  padding: 0 24px;
  background-color: ${color.WHITE};
  border-bottom: 1px solid ${color.GREY};
`;

export const tabsStyles = css`
  display: flex;
  align-self: stretch;
  flex-wrap: wrap;
`;

export const tabLinkStyles = css`
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  color: #5a6478;
  border-bottom: 2px solid ${color.TRANSPARENT};
  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    color: ${color.BLUE};
  }

  &.active {
    color: ${color.BLUE};
    border-bottom-color: ${color.BLUE};
  }
`;
